/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ReceiveWorkOSWebhookRequest = {
  /**
   * WorkOS webhook signature header
   */
  workOSSignature?: string | undefined;
};

/** @internal */
export type ReceiveWorkOSWebhookRequest$Outbound = {
  "WorkOS-Signature"?: string | undefined;
};

/** @internal */
export const ReceiveWorkOSWebhookRequest$outboundSchema: z.ZodMiniType<
  ReceiveWorkOSWebhookRequest$Outbound,
  ReceiveWorkOSWebhookRequest
> = z.pipe(
  z.object({
    workOSSignature: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      workOSSignature: "WorkOS-Signature",
    });
  }),
);

export function receiveWorkOSWebhookRequestToJSON(
  receiveWorkOSWebhookRequest: ReceiveWorkOSWebhookRequest,
): string {
  return JSON.stringify(
    ReceiveWorkOSWebhookRequest$outboundSchema.parse(
      receiveWorkOSWebhookRequest,
    ),
  );
}
